
export let defaultTableHeader = {
  department_id: {
    index: null,
    text: '费用承担部门',
  },
  project_number: {
    index: null,
    text: '项目编号',
  },
  first_subject: {
    index: null,
    text: '一级科目',
  },
  second_subject: {
    index: null,
    text: '二级科目',
  },
  invoice_type: {
    index: null,
    text: '发票类型',
  },
  tax_rate: {
    index: null,
    text: '税率',
  },
  amount: {
    index: null,
    text: '含税金额',
  },
  invoice_count: {
    index: null,
    text: '发票张数',
  },
  desc: {
    index: null,
    text: '摘要',
  },
}


export let defaultBatchTableHeader = {
  department_id: {
    index: null,
    text: '费用承担部门',
  },
  project_number: {
    index: null,
    text: '项目编号',
  },
  first_subject: {
    index: null,
    text: '一级科目',
  },
  second_subject: {
    index: null,
    text: '二级科目',
  },
  amount: {
    index: null,
    text: '含税金额',
  },
  desc: {
    index: null,
    text: '摘要',
  },
}




// WEBPACK FOOTER //
// ./src/views/payment-manager-new/components/payment-manager-table-header.js